import * as Yup from 'yup';
import moment from 'moment';
import { RegularExpressions } from '../constants/regular-expressions';
import { getRequiredText } from '../helpers/transformer';
import { LabelSettingProps } from '../models/epi-model';
import { PersonPhoneValidationSchema } from './phone-number-form-validation';
import { PersonPhoneValues } from '../models/person-model';
import { replaceAll } from '../helpers/string-helpers';

export const personInfoSelfDescribeValue = 'Self-describe';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PersonInfoValidationSchema = (
    labelSetting: LabelSettingProps, 
    dobValue: string, 
    personPhoneValues: PersonPhoneValues,    
    ignore?: boolean, 
    taxIdSkip?: boolean, 
    dobSkip?: boolean) => {

	if (ignore) return {};

    let taxIdValidationBase = Yup.string().nullable().matches(RegularExpressions.SSN, labelSetting?.ssnInvalid || 'SSN is not valid.');
    if (!taxIdSkip){
        taxIdValidationBase = taxIdValidationBase.required(getRequiredText(labelSetting.requiredFormat, labelSetting.ssnTinLabel));
    }

    const taxIdValidation = taxIdValidationBase.test('taxid_valid_format', 
        (value, context) => { 
            const idStriped = replaceAll(value, '-', '');

            if (idStriped === '012345678' || 
                idStriped === '123456789'){
                return context.createError({ message: labelSetting?.ssnInvalid || 'SSN is not valid.' });            
            }

            return true;
        });

    return {
        first_name: Yup.string().required(getRequiredText(labelSetting.requiredFormat, labelSetting.firstNameLabel)),
        last_name: Yup.string().required(getRequiredText(labelSetting.requiredFormat, labelSetting.lastNameLabel)),
        gender: Yup.string().required(getRequiredText(labelSetting.requiredFormat, labelSetting.genderLabel)),
        date_of_birth: Yup.string().nullable()
        .test('valid_format', 
        (value, context) => {            
            const dobMasked = value?.includes('XX/XX/');
            if (dobSkip || dobMasked) return true;

            if (!value) return context.createError({ message: getRequiredText(labelSetting.requiredFormat, labelSetting.dobLabel) });

            const valueMoment = moment(value);

            if (!valueMoment.isValid()) return context.createError({ message: 'Invalid Format' });
            
            const nowMoment = moment();

            return valueMoment.diff(nowMoment) >= 0 ? context.createError({ message: labelSetting.dateFutureError || 'Date cannot be in the future' }) : true;            
        }),
        tax_id: taxIdValidation,
        gender_identity_other: Yup.string().ensure()
            .when(['gender_identity'], {
                is: (gender_identity: string[]) => {
                    return gender_identity?.length > 0 && gender_identity.includes(personInfoSelfDescribeValue);
                },
                then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, labelSetting.genderIdentitySelfDescribeLabel || 'Provide Description Below')),
            }), 
        ...PersonPhoneValidationSchema(labelSetting, personPhoneValues),              
    };
};
